import { ComposicaoDisponibilidade, VinculoQuantidade } from '../model/banca/ComposicaoDisponibilidade';

/**
 * Normaliza uma string removendo acentos
 */
export const normalizarTexto = (texto: string): string => {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

/**
 * Normaliza os papéis de uma composição removendo acentos e converte vinculosObrigatorios para vinculos
 */
export const normalizarComposicao = (composicao: ComposicaoDisponibilidade): ComposicaoDisponibilidade => {
    return {
        ...composicao,
        papeis: composicao.papeis.map(p => {
            // Converter vinculosObrigatorios para o formato vinculos esperado
            const vinculos: VinculoQuantidade[] = Object.entries(p.vinculosObrigatorios || {}).map(([vinculo, minimo]) => ({
                vinculo,
                minimo,
                maximo: minimo // Por enquanto, usar o mesmo valor para máximo
            }));

            return {
                ...p,
                papel: normalizarTexto(p.papel),
                vinculos
            };
        })
    };
};
